module.exports = __webpack_public_path__ + "static/media/pause.ecc0f1bd.png";